import { connect } from 'react-redux'

/**
HOC to pass relevant Redux state to Apollo query
*/
const mapStateToApolloProps = ({query}) => ({query})
const withReduxForApollo = connect(mapStateToApolloProps)

export default withReduxForApollo
